import React__default from 'react';
import DefaultColumn from './DefaultColumn.js';

var ColumnRenderer = function ColumnRenderer(_ref) {
  var dataTestId = _ref.dataTestId,
    innerRef = _ref.innerRef,
    column = _ref.column;
    _ref.grouped;
    var allowPinning = _ref.allowPinning,
    dragHandle = _ref.dragHandle,
    draggableProps = _ref.draggableProps;
  // TODO: multiple renderers depending on grouped columns
  return /*#__PURE__*/React__default.createElement(DefaultColumn, {
    dataTestId: dataTestId,
    innerRef: innerRef,
    data: column,
    dragHandle: dragHandle,
    draggableProps: draggableProps,
    allowPinning: allowPinning
  });
};

export { ColumnRenderer as default };
